import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

import { useTranslation } from "react-i18next";
import { styled, Box } from "~/common/mui";

interface Props {
  saving: boolean;
  className?: string;
}

const ICON_SIZE = 16;

const Root = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const StyledSpinner = styled(CircleSpinner)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.primary.main,
  width: ICON_SIZE,
  height: ICON_SIZE,
  fontSize: `${ICON_SIZE}px !important`,
}));

const StyledIcon = styled(Icon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.primary.main,
  width: ICON_SIZE,
  height: ICON_SIZE,
  fontSize: `${ICON_SIZE}px !important`,
}));

const SavingText = styled("span")(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

const SavedText = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const SavingIndicator = ({ saving, className }: Props) => {
  const { t } = useTranslation();

  if (saving) {
    return (
      <Root className={className}>
        <StyledSpinner />
        <SavingText>{t("generic.saving.inProgress")}</SavingText>
      </Root>
    );
  } else {
    return (
      <Root className={className}>
        <StyledIcon type={IconType.Check} />
        <SavedText>{t("generic.saving.done")}</SavedText>
      </Root>
    );
  }
};
